import { Phone } from 'lucide-react';
import { useState } from 'react';

import { useGetAudioConversationDetailListQuery } from '@/services/api/audioConversationService';

import {
  AudioConversationPlayer,
  AudioConversationPlayerSkeleton,
} from '../audio-conversation';
import { MatterSectionCard } from './MatterSectionCard';

interface CallsCardProps {
  matterId: string;
}

export const CallsCard = ({ matterId }: CallsCardProps) => {
  const [playingConversationId, setPlayingConversationId] = useState<
    string | null
  >(null);

  const { data: audioConversations, isLoading } =
    useGetAudioConversationDetailListQuery(matterId, {
      skip: !matterId,
    });

  const handlePlay = (conversationId: string) => {
    setPlayingConversationId(conversationId);
  };

  // Don't render if no calls
  if (!isLoading && (!audioConversations || audioConversations.length === 0)) {
    return null;
  }

  return (
    <MatterSectionCard
      title="Calls"
      icon={<Phone className="h-4 w-4" />}
      isLoading={isLoading}
    >
      {isLoading ? (
        <div className="space-y-2">
          {[1, 2].map((index) => (
            <AudioConversationPlayerSkeleton key={index} />
          ))}
        </div>
      ) : (
        <div className="space-y-2">
          {audioConversations?.map((conversation) => (
            <AudioConversationPlayer
              key={conversation.id}
              conversation={conversation}
              onPlay={() => handlePlay(conversation.id)}
              playingConversationId={playingConversationId}
              enableInspector
            />
          ))}
        </div>
      )}
    </MatterSectionCard>
  );
};
